import React from "react";
import '../../../model/index.css';

const P4 = () => {
  return (
    <div className="my-container">
      <h1 className="highlight">MICAZO RAMEN</h1>
      <div className="section">
        <h2>Valladolid, Spain.</h2>
        <p className="store-info"></p>
        <img src="./partner/4/1.pic.jpg"  alt=""/>
        <img src="./partner/4/2.pic.jpg"  alt=""/>
        <img src="./partner/4/3.pic.jpg"  alt=""/>
        <img src="./partner/4/4.pic.jpg"  alt=""/>
        <img src="./partner/4/5.pic.jpg"  alt=""/>
        <img src="./partner/4/6.pic.jpg"  alt=""/>
        <img src="./partner/4/7.pic.jpg"  alt=""/>
      </div>
    </div>
  );
};

export default P4;
